import { useTranslation } from 'react-i18next';
import FlowSteps from '../FlowSteps/FlowSteps';
import ProjectIcon from '../../ProjectIcon/ProjectIcon';
import ProjectVisual from '../../project/ProjectVisual/ProjectVisual';
import PillLink from '../../ui/PillLink/PillLink';
import { plainProjectName, type Project } from '../../../data/projects';
import { useProjectCopy } from '../../../hooks/useProjectCopy';
import { useLanguage } from '../../../i18n/useLanguage';
import type { AiFeatureCopy } from '../../../locales/types';
import styles from './AiFeature.module.css';

export default function AiFeature({ project }: { project: Project }) {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();
    const projectCopy = useProjectCopy()(project.slug);
    const feature = t(`ai.features.items.${project.slug}`, { returnObjects: true }) as unknown as AiFeatureCopy;
    const name = plainProjectName(project);
    const headingId = `ai-feature-${project.slug}`;

    return (
        <article className={styles.feature} aria-labelledby={headingId}>
            <div className={styles.media}>
                <ProjectVisual project={project} screenAlt={projectCopy.screenAlt} />
            </div>
            <div className={styles.text}>
                <p className={styles.product}>
                    <ProjectIcon project={project} size="small" />
                    {name}
                </p>
                <h3 id={headingId} className={styles.title}>{feature.title}</h3>
                <p className={styles.body}>{feature.body}</p>
                <PillLink href={localizedPath(`/work/${project.slug}`)} variant="outline" icon="arrowRight">
                    {t('project.open', { name })}
                </PillLink>
            </div>
            <FlowSteps label={t('ai.features.flowLabel')} steps={feature.flow} className={styles.flow} />
        </article>
    );
}
